module.exports = __webpack_public_path__ + "img/pk.5a76d0ae.png";